export default __webpack_public_path__ + "static/media/signature.b6444064.png";